<!-- ff-desktop is the one CSS scope for desktop styling. It follows isDesktopView(), which is
     false on native, so an iPad never gets desktop rules that a min-width media query would apply. -->
<ion-app [class.ff-desktop]="isDesktop">
  <ion-split-pane [when]="isDesktop" contentId="main-content" class="my-flock-pane">
    @if (isDesktop) {
      <ion-menu id="flockMenuBar" contentId="main-content" type="overlay" class="ff-menu" disabled="true">
        <ion-header mode="md" class="ion-no-border">
          <div class="ff-menu__brand">
            <button type="button" class="ff-menu__logo" (click)="goToHome()" aria-label="Dashboard">
              <img src="assets/logo/FF_Full_Logo_White_Green_4000x650.svg" alt="FlockFinder" />
            </button>
          </div>
          @if (userHoldings && userHoldings.length > 0) {
            @if (selectedHolding) {
              <button
                type="button"
                class="ff-menu__holding"
                (click)="openHoldingSelect()"
                [attr.aria-label]="'Switch holding, currently ' + selectedHolding.holdingName"
              >
                <span class="ff-menu__holding-avatar" aria-hidden="true">
                  {{ selectedHolding.holdingName.charAt(0).toUpperCase() }}
                </span>
                <span class="ff-menu__holding-text">
                  <span class="ff-menu__holding-name">{{ selectedHolding.holdingName }}</span>
                  <span class="ff-menu__holding-hint">Switch holding</span>
                </span>
                <ion-icon name="chevron-expand-outline" class="ff-menu__holding-chevron" aria-hidden="true"></ion-icon>
              </button>
            }
            <ion-select
              #holdingSelect
              [interfaceOptions]="customPopoverOptions"
              placeholder="select holding"
              (ionChange)="storeHoldingSelection($event)"
              [value]="selectedHolding?.id"
              class="hidden-select"
            >
              @for (holding of userHoldings; track holding) {
                <ion-select-option [value]="holding.id">
                  {{ holding.holdingName }}
                </ion-select-option>
              }
            </ion-select>
          }
          <div class="ff-menu__banners">
            <app-offline-banner></app-offline-banner>
            @if (selectedHolding?.holdingName === "FL/OCK/DEMO") {
              <app-tab-banner
                [theme]="'warning'"
                [bannerText]="'You are currently in demo mode.'"
                [icon]="'alert-circle-outline'"
              ></app-tab-banner>
            }
          </div>
        </ion-header>
        <ion-content>
          <nav class="ff-menu__nav" aria-label="Main">
            <div class="ff-menu__section" id="ff-menu-pages">Pages</div>
            <ion-list lines="none" aria-labelledby="ff-menu-pages">
              @for (entry of menuPages; track entry.key) {
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    button
                    detail="false"
                    [routerLink]="entry.path"
                    class="ff-menu__item"
                    [class.ff-menu__item--active]="isRouteActive(entry.key)"
                    [attr.aria-current]="isRouteActive(entry.key) ? 'page' : null"
                  >
                    @if (entry.iconSrc) {
                      <ion-icon
                        slot="start"
                        [src]="isRouteActive(entry.key) ? entry.activeIconSrc : entry.iconSrc"
                        aria-hidden="true"
                      ></ion-icon>
                    } @else {
                      <ion-icon
                        slot="start"
                        [name]="isRouteActive(entry.key) ? entry.activeIcon : entry.icon"
                        aria-hidden="true"
                      ></ion-icon>
                    }
                    <ion-label>{{ entry.label }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }
              <ion-menu-toggle auto-hide="false"><app-assistant-entry [menu]="true" /></ion-menu-toggle>
              <ion-item
                button
                detail="false"
                class="ff-menu__item ff-menu__item--group"
                [class.ff-menu__item--holds-active]="isMoreActive() && !isMoreExpanded"
                (click)="toggleMoreSection()"
                [attr.aria-expanded]="isMoreExpanded"
                aria-controls="ff-menu-more"
              >
                <ion-icon slot="start" name="ellipsis-horizontal" aria-hidden="true"></ion-icon>
                <ion-label>More</ion-label>
                <ion-icon
                  slot="end"
                  class="ff-menu__chevron"
                  [name]="isMoreExpanded ? 'chevron-up' : 'chevron-down'"
                  aria-hidden="true"
                ></ion-icon>
              </ion-item>
              <div
                class="ff-menu__children"
                id="ff-menu-more"
                [class.ff-menu__children--open]="isMoreExpanded"
                [attr.inert]="isMoreExpanded ? null : ''"
              >
                <div class="ff-menu__children-inner">
                @for (entry of menuMore; track entry.key) {
                  <ion-menu-toggle auto-hide="false">
                    <ion-item
                      button
                      detail="false"
                      (click)="navManage(entry.path)"
                      class="ff-menu__item ff-menu__item--child"
                      [class.ff-menu__item--active]="isRouteActive(entry.key)"
                      [attr.aria-current]="isRouteActive(entry.key) ? 'page' : null"
                    >
                      <ion-label>{{ entry.label }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                }
                </div>
              </div>
            </ion-list>

            <div class="ff-menu__section" id="ff-menu-account">Account</div>
            <ion-list lines="none" aria-labelledby="ff-menu-account">
              <ion-item
                button
                detail="false"
                class="ff-menu__item ff-menu__item--group"
                [class.ff-menu__item--holds-active]="isAccountActive() && !isAccountExpanded"
                (click)="toggleAccountSection()"
                [attr.aria-expanded]="isAccountExpanded"
                aria-controls="ff-menu-account-items"
              >
                <ion-icon slot="start" name="person-outline" aria-hidden="true"></ion-icon>
                <ion-label>Account</ion-label>
                <ion-icon
                  slot="end"
                  class="ff-menu__chevron"
                  [name]="isAccountExpanded ? 'chevron-up' : 'chevron-down'"
                  aria-hidden="true"
                ></ion-icon>
              </ion-item>
              <div
                class="ff-menu__children"
                id="ff-menu-account-items"
                [class.ff-menu__children--open]="isAccountExpanded"
                [attr.inert]="isAccountExpanded ? null : ''"
              >
                <div class="ff-menu__children-inner">
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    button
                    detail="false"
                    (click)="navigateTo('/manage/holdings')"
                    class="ff-menu__item ff-menu__item--child"
                    [class.ff-menu__item--active]="isRouteActive('holdings')"
                    [attr.aria-current]="isRouteActive('holdings') ? 'page' : null"
                  >
                    <ion-label>My Farms</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle *ffLisBeta auto-hide="false">
                  <ion-item
                    button
                    detail="false"
                    (click)="navigateTo('/account/connections')"
                    class="ff-menu__item ff-menu__item--child"
                    [class.ff-menu__item--active]="isRouteActive('connections')"
                    [attr.aria-current]="isRouteActive('connections') ? 'page' : null"
                  >
                    <ion-label>Connections</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                  <ion-item
                    button
                    detail="false"
                    routerLink="/account"
                    class="ff-menu__item ff-menu__item--child"
                    [class.ff-menu__item--active]="isRouteActive('account')"
                    [attr.aria-current]="isRouteActive('account') ? 'page' : null"
                  >
                    <ion-label>Account Settings</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                  <ion-item button detail="false" (click)="goToHelp()" class="ff-menu__item ff-menu__item--child">
                    <ion-label>Help</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle auto-hide="false">
                  <ion-item button detail="false" (click)="onLogout()" class="ff-menu__item ff-menu__item--child">
                    <ion-label>Log out</ion-label>
                  </ion-item>
                </ion-menu-toggle>
                </div>
              </div>
            </ion-list>
          </nav>
        </ion-content>
        <ion-footer class="ion-no-border">
          <div class="ff-menu__footer">
            <span class="ff-menu__version">v{{ appVersion }}</span>
            <a href="mailto:hello@flockfinder.co.uk" class="ff-menu__suggest">Suggest an improvement</a>
          </div>
        </ion-footer>
      </ion-menu>
    }
    <ion-router-outlet id="main-content"> </ion-router-outlet>
  </ion-split-pane>
</ion-app>
